import { currentTimeInMs } from 'tools/date'

export const isInstagramTokenExpired = (igTokenExpTime) => {
  const currentTimeInMinutes = currentTimeInMs() / 1000 / 60
  const igTokenExpTimeInMinutes = new Date(parseInt(igTokenExpTime, 10)).getTime() / 1000 / 60

  // as refreshing the token earlier produces no harm,
  // deduct the expiry date by 7 days to trigger the refresh earlier
  // just in case the cart doesn't has high volume of traffic
  const sevenDaysInMinutes = 7 * 24 * 60
  return igTokenExpTimeInMinutes - sevenDaysInMinutes <= currentTimeInMinutes
}
